<template>
  <div class="cw-object-table-wrap">

    <div class="cw-object-table">
      <div class="cw-object-table-head">
        <div class="list-row">
          <div class="col col-number">Lägenhetsnr</div>
          <div class="col col-rooms">Antal rum</div>
          <div class="col col-area">Storlek</div>
          <div class="col col-floor">Våning</div>
          <div class="col col-price">Pris</div>
          <div class="col col-status">Status</div>
        </div>
      </div>
      <div class="cw-object-table-body">
        <div class="list-row" v-for="row in sorted" :class="[{active: rowActive(row)}, 'status-'+row.status]"
             :ref="rowActive(row) ? 'activeObject' : null"
             @click="onRowClick(row)"
             @mouseenter="onRowMouseEnter(row)"
             @mouseleave="onRowMouseLeave(row)">
          <div class="col col-number nowrap">{{row.number}}</div>
          <div class="col col-rooms nowrap" v-if="row.data['rooms']">{{row.data['rooms']}} rok</div>
          <div class="col col-area nowrap">{{row.data['living_area']}} <span class="hidden-xs-down">m<sup>2</sup></span>
          </div>
          <div class="col col-floor nowrap">{{row.data['floor_number']}}</div>
          <div class="col col-price nowrap">{{row.data['price'] ? row.data['price']['formatted'] : '-'}}</div>
          <div class="col col-status nowrap">
            <span class="status" v-bind:class="'status-' + row.status">{{row.status_name}}</span>
          </div>
        </div>
      </div>
    </div>

    <!--<table class="cw-object-table">
      <thead>
      <tr class="list-row">
        <th class="col col-number">Lägenhetsnr</th>
        <th class="col col-rooms">Antal rum</th>
        <th class="col col-area">Storlek</th>
        <th class="col col-floor">Våning</th>
        <th class="col col-price">Pris</th>
        <th class="col col-status">Status</th>
      </tr>
      </thead>

      <tbody>
      <tr class="list-row" v-for="row in sorted" :class="[{active: rowActive(row)}, 'status-'+row.status]"
          :ref="rowActive(row) ? 'activeObject' : null"
          @click="onRowClick(row)"
          @mouseenter="onRowMouseEnter(row)"
          @mouseleave="onRowMouseLeave(row)">
        <td class="col col-number nowrap">{{row.number}}</td>
        <td class="col col-rooms nowrap" v-if="row.data['rooms']">{{row.data['rooms']}} rok</td>
        <td class="col col-area nowrap">{{row.data['living_area']}} <span class="hidden-xs-down">m<sup>2</sup></span></td>
        <td class="col col-floor nowrap">{{row.data['floor_number']}}</td>
        <td class="col col-price nowrap">{{row.data['price'] ? row.data['price']['formatted'] : '-'}}</td>
        <td class="col col-status nowrap">
          <span class="status" v-bind:class="'status-' + row.status">{{row.status_name}}</span>
        </td>
      </tr>
      </tbody>
    </table>-->
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'

  require('element.scrollintoviewifneeded-polyfill')

  export default {
    name: 'ObjectList',
    props: ['objects', 'activeObject'],
    data () {
      return {
        map: null,
        height: null,
        width: null,
        zoom: null,
        sort: 'number'
      }
    },
    watch: {
      activeObject () {
        if (!this.$refs.activeObject || !this.$refs.activeObject.length) {
          return
        }

        this.$refs.activeObject[0].scrollIntoViewIfNeeded()
      }
    },
    created () {
    },
    computed: {
      sorted () {
        return [].concat(this.objects)
          .sort((a, b) => {
            let an = parseInt(a.number, 10)
            let bn = parseInt(b.number, 10)

            if (an > bn) return 1
            else if (an < bn) return -1
            return 0
          })
      },
      ...mapGetters({
        objectsFiltered: 'getObjects'
      })
    },
    mounted () {
    },
    methods: {
      rowActive (row) {
        return this.activeObject ? row.id === this.activeObject.id : false
      },
      onRowClick (row) {
        this.$emit('rowclick', row)
      },
      onRowMouseEnter (row) {
        this.$emit('rowmouseenter', row)
      },
      onRowMouseLeave (row) {
        this.$emit('rowmouseleave', row)
      }
    },
    components: {}
  }
</script>
<style scoped lang="scss">
  .cw-object-table-wrap {

  }

  .cw-object-table {
    width: 100%;
  }

  .cw-object-table thead th {
    text-align: left;
  }

  .cw-object-table tbody tr {
    cursor: pointer;
  }

  .cw-object-table tbody tr:hover td,
  .cw-object-table tbody tr.active td {
    background: #eee;
  }

</style>



// WEBPACK FOOTER //
// src/components/ObjectList.vue